module.exports = __webpack_public_path__ + "static/media/picto-pencil-blue.fa70bacf.svg";